import Link from 'next/link'
import { sanitizeHTML } from '@/lib/utils'

interface SecCombineProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	content_collection?: {
		id: string
		site_content_collections_id: {
			collection: {
				item: {
					title: string | null
					text: string | null
					url?: string
				}
			}[]
		}
	}[]
}

export const fields = [
	// headings
	'heading.title',

	// text 
	'text.text',

	// content collection
	'content_collection.id',
	'content_collection.site_content_collections_id.collection.item:site_content.title',
	'content_collection.site_content_collections_id.collection.item:site_content.text',
	'content_collection.site_content_collections_id.collection.item:external_links.title',
	'content_collection.site_content_collections_id.collection.item:external_links.url'
] as const

export default function SecCombine({ data }: { data: SecCombineProps }) {
	const getGridClasses = (itemCount: number) => {
		let lgClasses = 'lg:grid-cols-3'
		let xlClasses = 'xl:grid-cols-3'

		if (itemCount === 5) {
			lgClasses = 'lg:grid-cols-3'
			xlClasses = 'xl:grid-cols-5'
		} else if (itemCount === 6) {
			lgClasses = 'lg:grid-cols-3'
			xlClasses = 'xl:grid-cols-3'
		} else if (itemCount === 7) {
			lgClasses = 'lg:grid-cols-3'
			xlClasses = 'xl:grid-cols-4'
		} else if (itemCount === 8) {
			lgClasses = 'lg:grid-cols-3'
			xlClasses = 'xl:grid-cols-4'
		}

		return `grid grid-cols-1 md:grid-cols-2 ${lgClasses} ${xlClasses} gap-8`
	}

	const itemCount = data?.content_collection?.length || 0

	return (
		<section id='combine' className='SecCombine py-16'>
			<div className='container'>
				{/* Header Section */}
				<div className='flex flex-col items-start gap-8 mb-14 w-full md:w-10/12'>
					<div className='flex flex-col gap-12'>
						<h2>{data?.heading?.title || ''}</h2>
					</div>
					<div
						className='tracking-wide prose prose-p:mb-6 prose-li:mb-4'
						dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
					/>
				</div>

				{/* Procedures Grid */}
				<div className={`ProceduresGrid ${getGridClasses(itemCount)}`}>
					{data?.content_collection?.map((item, index) => {
						
						const titleItem = item.site_content_collections_id.collection.find(
							c => c.item.title && !('url' in c.item)
						)?.item
						
						const textItem = item.site_content_collections_id.collection.find(
							c => c.item.text
						)?.item
						
						const externalLink = item.site_content_collections_id.collection.find(
							c => 'url' in c.item
						)?.item

						return (
							<div key={item.id} className='flex flex-col justify-between md:mb-12'>
								<div className='flex flex-col gap-9'>
									<div className='flex flex-col'>
										{/* <span className='text-base uppercase leading-9'>
											Procedure {index + 1}
										</span> */}
										<h3>{titleItem?.title || ''}</h3>
									</div>
									<div
										className='prose prose-p:mb-6 prose-li:mb-4'
										dangerouslySetInnerHTML={sanitizeHTML(textItem?.text || '')}
									/>
								</div>
								{externalLink?.url && (
									<Link
										href={externalLink.url}
										className='h-14 px-12 py-[11px] bg-brown/30 rounded-lg text-2xl font-brandon leading-9 text-center mt-8 md:mt-14 max-md:mb-8 hover:bg-brown transition-colors'
									>
										<span className='text-center text-2xl font-brandon leading-9'>
											Read more
											{/* {externalLink.title || 'Read more'} */}
										</span>
									</Link>
								)}
							</div>
						)
					})}
				</div>
			</div>
		</section>
	)
}
